import React from 'react';
import ShutdownAlertIcon from '@/comp/common/icons/ShutdownAlertIcon';
import WarningAlertIcon from '@/comp/common/icons/WarningAlertIcon';
import ServiceAlertIcon from '@/comp/common/icons/ServiceAlertIcon';
import BoxArrowDownIcon from '@/comp/common/icons/BoxArrowDownIcon';

export const ALERT_TAB_KEYS = {
  ALL: 'all',
  SHUTDOWN: 'shutdown',
  WARNING: 'warning',
  SERVICE: 'service',
  ARCHIVED: 'archived',
} as const;

export type AlertTabKey = (typeof ALERT_TAB_KEYS)[keyof typeof ALERT_TAB_KEYS];

export interface AlertTabConfig {
  key: AlertTabKey;
  translationKey: string;
  icon?: React.ComponentType;
  className?: string;
  showCount?: boolean;
}

export const ALERT_TAB_CONFIGS: AlertTabConfig[] = [
  {
    key: ALERT_TAB_KEYS.ALL,
    translationKey: 'All',
    showCount: true,
  },
  {
    key: ALERT_TAB_KEYS.SHUTDOWN,
    translationKey: 'Shutdown',
    icon: ShutdownAlertIcon,
    showCount: true,
  },
  {
    key: ALERT_TAB_KEYS.WARNING,
    translationKey: 'Warning',
    icon: WarningAlertIcon,
    showCount: true,
  },
  {
    key: ALERT_TAB_KEYS.SERVICE,
    translationKey: 'Service',
    icon: ServiceAlertIcon,
    showCount: true,
  },
  {
    key: ALERT_TAB_KEYS.ARCHIVED,
    translationKey: 'Archived',
    icon: BoxArrowDownIcon,
    className: 'archived',
    showCount: false,
  },
];

